import { Stack, Typography } from "@mui/material";
import React from "react";

interface Props {
  label: string;
  value: string;
}

export function Desc({ label, value }: Props) {
  return (
    <>
      <Stack direction="row" spacing={1}>
        <Typography variant="body1" color="#808080">
          {`${label}:`}
        </Typography>
        <Typography variant="body1">{value}</Typography>
      </Stack>
    </>
  );
}

export function Title(props: any) {
  return <Typography variant="h4">{props.text}</Typography>;
}

export function Subtitle(props: any) {
  return <Typography variant="h5">{props.text}</Typography>;
}

export function Subsubtitle(props: any) {
  return <Typography variant="h6">{props.text}</Typography>;
}
